import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { OverlayTooltipComponent } from './tooltip/overlay-tooltip/overlay-tooltip.component'
import { MobileTooltipDirective } from './tooltip/mobile-tooltip.directive'
import { TooltipDirective } from './tooltip/tooltip.directive'
import { SharedPolymorpheusModule } from '@alliance/shared/polymorpheus'

@NgModule({
  declarations: [OverlayTooltipComponent, MobileTooltipDirective, TooltipDirective],
  exports: [OverlayTooltipComponent, MobileTooltipDirective, TooltipDirective],
  imports: [CommonModule, SharedPolymorpheusModule]
})
export class SantaTooltipModule {}
